const defaultServerUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8002' : '';
const serverUrl = (process.env.REACT_APP_SERVER_URL || defaultServerUrl).replace(/\/+$/, '');
export const teacherApiBase = `${serverUrl}/teacher-lms`;
export const studentApiBase = `${serverUrl}/student-question-bank`;
export const TEACHER_SESSION_EXPIRED_EVENT = 'teacher-lms:session-expired';
export const STUDENT_SESSION_EXPIRED_EVENT = 'student-question-bank:session-expired';

function parseUrl(value, base = window.location.origin) {
  try { return new URL(value, base); } catch { return null; }
}

function isStaticAsset(pathname) {
  return /^\/(?:teacher-lms-assets|static|assets|images|fonts|sounds)\//i.test(pathname)
    || /\.(?:pdf|png|jpe?g|webp|svg|gif|ico|woff2?|ttf|otf|mp[34]|wav|ogg|css|m?js|map|txt|html?)$/i.test(pathname);
}

// Legacy components keep their API paths; only requests to this application's
// API are namespaced. Signed S3 URLs, blobs and third-party assets stay intact.
function namespacedApiUrl(value, namespace, preserveNamespace = false) {
  if (typeof value !== 'string' || !value.trim() || /^(?:data|blob):/i.test(value)) return value;
  const origin = window.location.origin;
  const base = parseUrl(serverUrl || '/', origin);
  if (!base || !/^https?:$/.test(base.protocol)) return value;
  const requested = parseUrl(value, `${base.origin}${base.pathname.replace(/\/+$/, '')}/`);
  if (!requested || !/^https?:$/.test(requested.protocol) || requested.username || requested.password) return value;
  if (requested.origin !== base.origin && requested.origin !== origin) return value;
  let pathname = requested.pathname;
  if (isStaticAsset(pathname)) return value;
  const basePath = base.pathname.replace(/\/+$/, '');
  if (basePath && (pathname === basePath || pathname.startsWith(`${basePath}/`))) pathname = pathname.slice(basePath.length);
  if (pathname === '/api' || pathname.startsWith('/api/')) pathname = pathname.slice(4);
  const existingNamespace = /^\/(teacher-lms|student-question-bank)(?:\/|$)/.exec(pathname)?.[1];
  if (!(preserveNamespace && existingNamespace) && existingNamespace !== namespace) {
    pathname = `/${namespace}${pathname.startsWith('/') ? '' : '/'}${pathname}`;
  }
  return `${base.origin}${basePath}${pathname}${requested.search}`;
}

export function teacherApiUrl(value) {
  return namespacedApiUrl(value, 'teacher-lms');
}

export function studentApiUrl(value) {
  return namespacedApiUrl(value, 'student-question-bank');
}

// The same legacy pages serve two separately authenticated workspaces. Select
// their API at request time; a stored account role must not change the route.
export function legacyApiUrl(value) {
  const studentPage = /^\/lms\/question-bank(?:\/|$)/.test(window.location.pathname);
  return namespacedApiUrl(value, studentPage ? 'student-question-bank' : 'teacher-lms', true);
}

function isNamespacedApiUrl(value, apiBase) {
  if (typeof value !== 'string') return false;
  const actual = parseUrl(value);
  const expected = parseUrl(apiBase);
  return Boolean(actual && expected && !actual.username && !actual.password
    && actual.origin === expected.origin
    && (actual.pathname === expected.pathname || actual.pathname.startsWith(`${expected.pathname}/`)));
}

export function isTeacherApiUrl(value) { return isNamespacedApiUrl(value, teacherApiBase); }
export function isStudentApiUrl(value) { return isNamespacedApiUrl(value, studentApiBase); }
export function isLegacyApiUrl(value) { return isTeacherApiUrl(value) || isStudentApiUrl(value); }
